import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { getContent } from '../../util/responseUtil';
import FilterCustomerService from './FilterCustomerService';
import FilterDateRange from './FilterDateRange';
import API_SETTINGS from '../../api/apiSettings';

class FilterSettingsQueue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilter: false,
            showCollapse1: false,
            showCollapse2: false,
            userCustomerService: {
                page: 1,
                limit: 100,
                data: [],
                value: '',
                id: 0
            },
            startDate: '',
            endDate: '',
            serverTime: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleCollapse1 = () => {
        this.setState({
            showCollapse1: !this.state.showCollapse1,
            showCollapse2: false,
        })
    }

    handleCollapse2 = () => {
        this.setState({
            showCollapse1: false,
            showCollapse2: !this.state.showCollapse2,
        })
    }

    getListUserCustomerServiceFilterSettingQueue = () => {
        API_SETTINGS.getListUserCustomerServiceQueue(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        userCustomerService: {
                            ...this.state.userCustomerService,
                            data: getContent(res)
                        }
                    });
                }
            })
    }

    getSearchUserCustomerServiceFilterSettingsQueue = () => {
        API_SETTINGS.getSearchUserCustomerServiceFilterSettingsQueue(this.state.userCustomerService.page, this.state.userCustomerService.limit, this.state.userCustomerService.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        userCustomerService: {
                            ...this.state.userCustomerService,
                            data: getContent(res)
                        }
                    });
                }
            })
    }

    getDateRangeFilterSettingsQueue = (from, to) => {
        this.setState({
            startDate: from,
            endDate: to
        })
    }

    handleSelectCustomerServiceFilterSettingsQueue = data => {
        this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: data.name,
                id: data.user_nexcare_id
            }
        })
    }

    handleChangeCustomerServiceFilterSettingsQueue = async e => {
        await this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: e.target.value
            }
        })
        if (this.state.userCustomerService.value === '') {
            this.getListUserCustomerServiceFilterSettingQueue();
        } else {
            this.getSearchUserCustomerServiceFilterSettingsQueue();
        }
    }

    handleClearFilterSettingsQueue = async () => {
        this.setState({
            userCustomerService: {
                ...this.state.userCustomerService,
                value: '',
                id: 0
            }
        })
        this.getListUserCustomerServiceFilterSettingQueue();
    }

    handleDateRange = (from, to) => {
        this.setState({
            startDate: moment(from).format('YYYY-MM-DD'),
            endDate: moment(to).format('YYYY-MM-DD')
        })
    }

    handleFilterSettingsQueue = () => {
        let filter = {
            customerService: this.state.userCustomerService.id,
            startDate: this.state.startDate === '' ? '' : moment(this.state.startDate).format('YYYY-MM-DD'),
            endDate: this.state.endDate === '' ? '' : moment(this.state.endDate).format('YYYY-MM-DD'),
        }
        this.props.handleFilter(filter)

        this.setState({
            showFilter: false,
            showCollapse1: false,
            showCollapse2: false,
        })
    }

    handleResetFilterSettingsQueue = () => {
        this.setState({
            showFilter: false,
            showCollapse1: false,
            showCollapse2: false,
            userCustomerService: {
                ...this.state.userCustomerService,
                value: '',
                id: 0
            },
            startDate: '',
            endDate: ''
        })
        this.props.resetFilter()
    }

    handleCollapseFilter = e => {
        if (this.filterButtonRef.current === null || this.filterRef.current === null) {
            return
        }
        if (this.filterButtonRef && !this.filterButtonRef.current.contains(e.target) && this.filterRef && !this.filterRef.current.contains(e.target)) {
            this.setState({
                showFilter: false
            })
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.filterButtonRef = createRef();
        this.filterRef = createRef();

        this.getListUserCustomerServiceFilterSettingQueue();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showFilter !== this.state.showFilter) {
            if (this.state.showFilter) {
                document.addEventListener('click', this.handleCollapseFilter)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('click', this.handleCollapseFilter);
    }

    render() {
        return (
            <div className="relative">
                <div className={this.state.showFilter ? "dropdown opened" : "dropdown"} tabIndex="-1">
                    <div
                        className="dropdown-select"
                        id="btnsettingsqueue"
                        onClick={() => this.setState({ showFilter: !this.state.showFilter, showCollapse1: !this.state.showCollapse1 })}
                        ref={this.filterButtonRef}
                    >
                        <p className="mr-2">Pilih Filter</p>
                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                    </div>
                </div>
                {
                    this.state.showFilter &&
                    <div className="absolute bg-white shadow-lg rounded-lg mt-1 w-full text-gray-600 select-none z-50" ref={this.filterRef}>
                        <div className="border-b border-gray-300 py-2">
                            <div className="flex justify-between items-center px-5" id="btncollapse1" onClick={() => this.handleCollapse1()}>
                                <p className="font-medium">Nama CS</p>
                                <FontAwesomeIcon icon={this.state.showCollapse1 ? faChevronUp : faChevronDown} className="text-darkblue" />
                            </div>
                            {
                                this.state.showCollapse1 &&
                                <div className="bg-blue-50 px-5 mt-1">
                                    <FilterCustomerService
                                        data={this.state.userCustomerService}
                                        handleChangeCustomerService={this.handleChangeCustomerServiceFilterSettingsQueue}
                                        handleSelectCustomerService={this.handleSelectCustomerServiceFilterSettingsQueue}
                                        handleClear={this.handleClearFilterSettingsQueue}
                                    />
                                </div>
                            }
                        </div>
                        <div className="border-b border-gray-300 py-2">
                            <div className="flex justify-between items-center px-5" id="btncollapse2" onClick={() => this.handleCollapse2()}>
                                <p className="font-medium">Tanggal</p>
                                <FontAwesomeIcon icon={this.state.showCollapse2 ? faChevronUp : faChevronDown} className="text-darkblue" />
                            </div>
                            {
                                this.state.showCollapse2 &&
                                <div className="px-5 mt-1">
                                    <FilterDateRange
                                        getDateRange={this.getDateRangeFilterSettingsQueue}
                                    />
                                </div>
                            }
                        </div>
                        <div className="flex justify-between items-center my-3 mx-5">
                            <button
                                type="button"
                                id="btnreset"
                                className="bg-darkred rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleResetFilterSettingsQueue()}
                            >
                                Reset
                            </button>
                            <button
                                type="button"
                                id="btnfilter"
                                className="bg-lightblue rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleFilterSettingsQueue()}
                            >
                                Terapkan
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(FilterSettingsQueue);